// Holds the AI-parsed resume (structured JSON from GetParsedResume) so every
// profile-builder page can read it to pre-fill fields without re-fetching.
export const SET_PARSED_RESUME = "SET_PARSED_RESUME";
export const CLEAR_PARSED_RESUME = "CLEAR_PARSED_RESUME";

export const initialState = null;

const parsedResumeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_PARSED_RESUME:
            return payload;
        case CLEAR_PARSED_RESUME:
            return null;
        default:
            return state;
    }
};

export const setParsedResume = (payload) => (dispatch) => {
    dispatch({ type: SET_PARSED_RESUME, payload });
};

export const clearParsedResume = () => (dispatch) => {
    dispatch({ type: CLEAR_PARSED_RESUME });
};

export default parsedResumeReducer;
